import { UtensilsCrossed, Drumstick, Dumbbell, Shirt, ShoppingBasket, Plus, Smartphone, Wine, Utensils, Wheat, Scissors, Coffee } from "lucide-react";

// Business types shown on screen 1
export const BUSINESS_TYPES = [
  { id: "taqueria", label: "Taquería", icon: UtensilsCrossed },
  { id: "polleria", label: "Pollería", icon: Drumstick },
  { id: "gym", label: "Gym funcional", icon: Dumbbell },
  { id: "ropa", label: "Tienda de ropa", icon: Shirt },
  { id: "abarrotes", label: "Abarrotes", icon: ShoppingBasket },
  { id: "venta_redes", label: "Venta por redes", icon: Smartphone },
  { id: "bar", label: "Bar", icon: Wine },
  { id: "puesto", label: "Puesto de comida", icon: Utensils },
  { id: "tortilleria", label: "Tortillería", icon: Wheat },
  { id: "estetica", label: "Estética / Barbería", icon: Scissors },
  { id: "cafeteria", label: "Cafetería", icon: Coffee },
  { id: "otro", label: "Otro", icon: Plus },
];

// Why-it-matters subtext (shown under every question)
const WHY = "Esto nos ayuda a personalizar tu estrategia";

// Questions per business type
// Each question: { key, label, options: [string] | null (means free text), why }
// The free text question for "otro" uses type: "text"
export const QUESTIONS = {
  taqueria: [
    {
      key: "volumen",
      label: "¿Cuántos tacos vendes por día?",
      options: ["Menos de 100", "100 – 300", "Más de 300"],
      why: WHY,
    },
    {
      key: "nocturno",
      label: "¿Tienes horario nocturno?",
      options: ["Sí", "No"],
      why: WHY,
    },
    {
      key: "domicilio",
      label: "¿Ofreces domicilio?",
      options: ["Sí", "No", "Quiero ofrecerlo"],
      why: WHY,
    },
    {
      key: "redes",
      label: "¿Tienes perfil en Google Maps o redes sociales?",
      options: ["Sí, activo", "Sí, pero sin actividad", "No tengo"],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu mayor reto?",
      options: [
        "Atraer clientes nuevos",
        "Que regresen",
        "Vender más por visita",
      ],
      why: WHY,
    },
    {
      key: "competencia",
      label: "¿Cuánta competencia hay cerca?",
      options: ["Soy el único", "2 – 3", "Muchos"],
      why: WHY,
    },
  ],
  polleria: [
    {
      key: "volumen",
      label: "¿Cuántos pollos vendes por día?",
      options: ["Menos de 20", "20 – 40", "Más de 40"],
      why: WHY,
    },
    {
      key: "domicilio",
      label: "¿Ofreces servicio a domicilio?",
      options: ["Sí", "No", "A veces"],
      why: WHY,
    },
    {
      key: "horas_muertas",
      label: "¿Tienes horas muertas?",
      options: ["Sí, de 12 a 2pm", "Sí, por las mañanas", "No tengo"],
      why: WHY,
    },
    {
      key: "combos",
      label: "¿Tienes combos o solo piezas sueltas?",
      options: ["Solo piezas", "Tengo combos", "Quiero crear combos"],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu mayor reto?",
      options: ["Más clientes", "Llenar horas muertas", "Aumentar ticket"],
      why: WHY,
    },
    {
      key: "whatsapp",
      label: "¿Usas WhatsApp para pedidos?",
      options: ["Sí, mucho", "Poco", "No"],
      why: WHY,
    },
  ],
  gym: [
    {
      key: "miembros",
      label: "¿Cuántos miembros activos tienes?",
      options: ["Menos de 30", "30 – 80", "Más de 80"],
      why: WHY,
    },
    {
      key: "clases",
      label: "¿Ofreces clases grupales, personalizadas o ambas?",
      options: ["Solo grupales", "Solo personalizadas", "Ambas"],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu reto principal?",
      options: [
        "Conseguir miembros",
        "Evitar cancelaciones",
        "Llenar horarios muertos",
      ],
      why: WHY,
    },
    {
      key: "redes",
      label: "¿Tienes Instagram o Facebook activo?",
      options: ["Sí, con contenido", "Tengo pero sin actividad", "No tengo"],
      why: WHY,
    },
    {
      key: "programa",
      label: "¿Tienes algún programa especial?",
      options: ["Niños", "Adultos mayores", "Ninguno"],
      why: WHY,
    },
    {
      key: "adquisicion",
      label: "¿Cómo llegan tus nuevos miembros?",
      options: ["Recomendación", "Redes sociales", "Pasan y entran"],
      why: WHY,
    },
  ],
  ropa: [
    {
      key: "canal",
      label: "¿Tu tienda es física, online o ambas?",
      options: ["Solo física", "Solo online", "Ambas"],
      why: WHY,
    },
    {
      key: "publico",
      label: "¿A quién le vendes principalmente?",
      options: ["Mujeres", "Hombres", "Ambos"],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu reto?",
      options: [
        "Atraer clientas nuevas",
        "Que regresen",
        "Mover inventario estancado",
      ],
      why: WHY,
    },
    {
      key: "instagram",
      label: "¿Usas Instagram para vender?",
      options: ["Sí, activamente", "Tengo pero poco", "No uso"],
      why: WHY,
    },
    {
      key: "temporada",
      label: "¿Tienes temporada alta?",
      options: ["Sí, diciembre", "Sí, quincenas", "Todo el año parejo"],
      why: WHY,
    },
    {
      key: "credito",
      label: "¿Ofreces apartar o crédito?",
      options: ["Sí", "No", "A veces a conocidas"],
      why: WHY,
    },
  ],
  abarrotes: [
    {
      key: "clientes",
      label: "¿Cuántos clientes al día tienes aprox.?",
      options: ["Menos de 30", "30 – 80", "Más de 80"],
      why: WHY,
    },
    {
      key: "extras",
      label: "¿Ofreces algo extra además de abarrotes?",
      options: [
        "Recargas de celular",
        "Frutas y verduras",
        "Solo abarrotes",
      ],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Tu mayor problema?",
      options: [
        "Productos que no rotan",
        "Competencia de Oxxo o tiendas grandes",
        "Falta de clientes nuevos",
      ],
      why: WHY,
    },
    {
      key: "promociones",
      label: "¿Tienes alguna promoción activa?",
      options: ["Sí, siempre", "A veces", "Nunca"],
      why: WHY,
    },
    {
      key: "credito",
      label: "¿Fías o das crédito a clientes?",
      options: ["Sí, a muchos", "Solo a conocidos", "No fío"],
      why: WHY,
    },
    {
      key: "whatsapp",
      label: "¿Usas WhatsApp con tus clientes?",
      options: ["Sí, para pedidos", "A veces", "No"],
      why: WHY,
    },
  ],
  venta_redes: [
    {
      key: "producto",
      label: "¿Qué vendes principalmente?",
      options: [
        "Accesorios y bisutería",
        "Ropa y moda",
        "Productos de belleza",
        "Suplementos y salud",
        "Artículos del hogar",
        "Otro",
      ],
      why: WHY,
    },
    {
      key: "red_social",
      label: "¿En qué red social vendes más?",
      options: ["Instagram", "Facebook", "TikTok", "WhatsApp", "Varias por igual"],
      why: WHY,
    },
    {
      key: "seguidores",
      label: "¿Cuántos seguidores o contactos tienes aprox.?",
      options: ["Menos de 500", "500 a 2,000", "2,000 a 10,000", "Más de 10,000"],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu mayor problema ahora mismo?",
      options: [
        "Conseguir más seguidores",
        "Que los que me ven me compren",
        "Conseguir proveedores",
        "Que me recomienden más",
      ],
      why: WHY,
    },
    {
      key: "catalogo",
      label: "¿Tienes catálogo o publicas producto por producto?",
      options: [
        "Tengo catálogo",
        "Publico uno por uno",
        "No tengo nada organizado todavía",
      ],
      why: WHY,
    },
    {
      key: "tiempo",
      label: "¿Cuánto llevas vendiendo por redes?",
      options: ["Apenas empiezo", "Menos de 1 año", "1 a 3 años", "Más de 3 años"],
      why: WHY,
    },
  ],
  bar: [
    {
      key: "horario",
      label: "¿Cuál es tu horario principal?",
      options: ["Mediodía a tarde", "Tarde a noche", "Solo fines de semana"],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Tu mayor reto?",
      options: [
        "Llenar entre semana",
        "Aumentar consumo por mesa",
        "Conseguir clientes nuevos",
      ],
      why: WHY,
    },
    {
      key: "eventos",
      label: "¿Tienes música en vivo o eventos especiales?",
      options: ["Sí, frecuentemente", "A veces", "No"],
      why: WHY,
    },
    {
      key: "adquisicion",
      label: "¿Cómo llegan tus clientes actualmente?",
      options: ["Recomendación", "Redes sociales", "Pasan y entran"],
      why: WHY,
    },
    {
      key: "botanas",
      label: "¿Tienes menú de botanas?",
      options: ["Solo bebidas", "Botanas básicas", "Menú completo de comida"],
      why: WHY,
    },
    {
      key: "whatsapp",
      label: "¿Usas WhatsApp o redes para promociones?",
      options: ["Sí, activamente", "Poco", "No uso"],
      why: WHY,
    },
  ],
  puesto: [
    {
      key: "producto",
      label: "¿Qué vendes principalmente?",
      options: ["Tacos", "Tortas", "Comida corrida", "Antojitos", "Otro"],
      why: WHY,
    },
    {
      key: "ubicacion",
      label: "¿Dónde está tu puesto?",
      options: [
        "Mercado",
        "Calle fija",
        "Tianguis",
        "Afuera de escuela u oficina",
      ],
      why: WHY,
    },
    {
      key: "clientes",
      label: "¿Cuántos clientes al día tienes aprox.?",
      options: ["Menos de 30", "30 a 80", "Más de 80"],
      why: WHY,
    },
    {
      key: "horas_muertas",
      label: "¿Tienes horas muertas?",
      options: [
        "Mañana antes de las 12",
        "Tarde después de las 3",
        "No tengo",
      ],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Tu mayor problema?",
      options: ["Que me descubran", "Que regresen", "Vender más por visita"],
      why: WHY,
    },
    {
      key: "pedidos",
      label: "¿Tienes número para pedidos o todo es de paso?",
      options: [
        "Solo de paso",
        "Tengo número fijo",
        "Acepto pedidos por WhatsApp",
      ],
      why: WHY,
    },
  ],
  tortilleria: [
    {
      key: "kilos",
      label: "¿Cuántos kilos produces por día?",
      options: ["Menos de 50kg", "50 a 150kg", "Más de 150kg"],
      why: WHY,
    },
    {
      key: "cliente",
      label: "¿A quién le vendes principalmente?",
      options: [
        "Solo al menudeo (personas)",
        "Solo mayoreo (taquerías, fondas)",
        "Ambos",
      ],
      why: WHY,
    },
    {
      key: "diferenciador",
      label: "¿Tienes algo diferente a la competencia?",
      options: [
        "Maíz criollo o nixtamal propio",
        "Precio más bajo",
        "Mejor calidad",
        "Solo tortilla estándar",
      ],
      why: WHY,
    },
    {
      key: "horario",
      label: "¿Cuáles son tus horas de mayor venta?",
      options: [
        "Mañana (6-10am)",
        "Mediodía (11am-2pm)",
        "Todo el día parejo",
      ],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Tu mayor reto?",
      options: [
        "Conseguir clientes nuevos",
        "Que los actuales compren más",
        "Entrar a taquerías o restaurantes",
      ],
      why: WHY,
    },
    {
      key: "whatsapp",
      label: "¿Usas WhatsApp con tus clientes?",
      options: [
        "Sí, tengo lista de clientes",
        "Solo para pedidos",
        "No uso WhatsApp",
      ],
      why: WHY,
    },
  ],
  estetica: [
    {
      key: "servicios",
      label: "¿Qué servicios ofreces principalmente?",
      options: [
        "Corte de cabello",
        "Tinte y coloración",
        "Manicure y pedicure",
        "Barba y afeitado",
        "Todos los anteriores",
      ],
      why: WHY,
    },
    {
      key: "adquisicion",
      label: "¿Cómo llegan tus clientes nuevos?",
      options: [
        "Por recomendación",
        "Me ven en Instagram",
        "Pasan y entran",
        "Por WhatsApp",
      ],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu mayor reto?",
      options: [
        "Llenar la agenda entre semana",
        "Que los clientes regresen",
        "Conseguir clientes nuevos",
      ],
      why: WHY,
    },
    {
      key: "fotos",
      label: "¿Publicas fotos de tus trabajos en redes?",
      options: ["Sí, seguido", "A veces", "Casi nunca"],
      why: WHY,
    },
    {
      key: "promocion",
      label: "¿Tienes promoción o día especial?",
      options: [
        "Sí, tengo día de descuento",
        "Sí, para clientes frecuentes",
        "No tengo promoción",
      ],
      why: WHY,
    },
    {
      key: "whatsapp",
      label: "¿Usas WhatsApp para agendar citas?",
      options: [
        "Sí, es mi canal principal",
        "A veces",
        "No, todo es de paso",
      ],
      why: WHY,
    },
  ],
  cafeteria: [
    {
      key: "producto",
      label: "¿Qué ofreces principalmente?",
      options: [
        "Solo café de especialidad",
        "Café + desayunos o snacks",
        "Café + postres y pasteles",
        "Café + todo lo anterior",
      ],
      why: WHY,
    },
    {
      key: "horario_pico",
      label: "¿Cuándo tienes más clientes?",
      options: [
        "Mañana (7am–12pm)",
        "Mediodía (12pm–3pm)",
        "Tarde (3pm–8pm)",
        "Todo el día parejo",
      ],
      why: WHY,
    },
    {
      key: "llegada",
      label: "¿Cómo llegan tus clientes nuevos?",
      options: [
        "Por recomendación",
        "Me encuentran en Google Maps",
        "Por Instagram o Facebook",
        "Casi no llegan clientes nuevos",
      ],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu mayor reto?",
      options: [
        "Llenar las horas muertas",
        "Que los clientes regresen más seguido",
        "Conseguir clientes nuevos",
        "Competir con cadenas como Starbucks",
      ],
      why: WHY,
    },
    {
      key: "diferenciador",
      label: "¿Qué te hace diferente?",
      options: [
        "Café de especialidad u origen",
        "Ambiente único o instagrameable",
        "Precio más accesible que las cadenas",
        "Atención personalizada y cercana",
      ],
      why: WHY,
    },
    {
      key: "redes",
      label: "¿Usas WhatsApp o redes con clientes?",
      options: [
        "Sí, tengo comunidad activa",
        "A veces publico en Instagram",
        "Casi no uso redes",
        "No tengo presencia digital",
      ],
      why: WHY,
    },
  ],
  otro: [
    {
      key: "descripcion",
      label: "¿Cómo se llama tu negocio y qué vende?",
      type: "text",
      placeholder: "Ej: 'Dulcería La Estrella, vendo dulces y botanas'",
      why: WHY,
    },
    {
      key: "clientes",
      label: "¿Cuántos clientes tienes por día?",
      options: ["Menos de 10", "10 – 30", "Más de 30"],
      why: WHY,
    },
    {
      key: "adquisicion",
      label: "¿Cómo consigues clientes ahora?",
      options: ["Boca a boca", "Redes sociales", "Publicidad"],
      why: WHY,
    },
    {
      key: "reto",
      label: "¿Cuál es tu mayor problema?",
      options: ["Atraer clientes", "Que regresen", "Cobrar mejor"],
      why: WHY,
    },
    {
      key: "digital",
      label: "¿Tienes presencia digital?",
      options: ["Sí, activa", "Poca", "No tengo"],
      why: WHY,
    },
    {
      key: "mejora",
      label: "¿Qué quieres mejorar primero?",
      options: ["Mis redes", "Mis precios", "La atención"],
      why: WHY,
    },
  ],
};

export const BUSINESS_LABEL = {
  taqueria: "taquería",
  polleria: "pollería",
  gym: "gimnasio funcional",
  ropa: "tienda de ropa",
  abarrotes: "tienda de abarrotes",
  venta_redes: "venta por redes",
  bar: "bar",
  puesto: "puesto de comida",
  tortilleria: "tortillería",
  estetica: "estética o barbería",
  cafeteria: "cafetería",
  otro: "negocio",
};

// CORRECCIÓN 3: Optional open question appended to every questionnaire as the final step.
// Stored under answers.extra and surfaced into prompts via applyExtra() in prompts.js.
export const EXTRA_QUESTION = {
  key: "extra",
  label: "¿Algo especial de tu negocio que debamos saber para personalizar mejor?",
  placeholder:
    "Ej: solo atiendo mujeres, soy el único en mi colonia, vendo a mayoreo, tengo promoción esta semana...",
  type: "text",
  optional: true,
  maxLength: 150,
  why: "Esto nos ayuda a personalizar tu estrategia",
};

// Price of the main product/service. Captured as the penultimate question for every
// giro. When provided, templates.js feeds it into PRECIO_1 and derives PRECIO_COMBO_NOCHE,
// PRECIO_KILO, PRECIO_MEDIO and PRECIO_ENTERO (math done in JS — users only see numbers).
// When empty, every derived price falls back to "[agrega tu precio aquí]" exactly as before.
export const PRECIO_QUESTION = {
  key: "precio_1",
  label: "¿Cuánto cuesta tu producto o servicio principal?",
  placeholder: "Ej: 18 (solo el número, sin $ ni ceros)",
  type: "number",
  optional: true,
  helper: "Esto nos permite calcular combos y promociones con tus precios reales",
  why: "Esto nos ayuda a personalizar tu estrategia",
};

// Financial-context questions. Both optional, valid for every giro, rendered together
// under an orange section header so the user understands they are a different "track"
// from the giro-specific questions. Their answers gate the visibility of the META
// section in the third output of every prompt/ready-text bundle.
export const INGRESOS_QUESTION = {
  key: "ingresos_actuales",
  label: "¿Cuánto ganas aproximadamente al mes con tu negocio?",
  options: [
    "Menos de $5,000",
    "Entre $5,000 y $15,000",
    "Entre $15,000 y $30,000",
    "Más de $30,000",
    "Prefiero no decirlo",
  ],
  optional: true,
  groupHeader: "Opcional: esto personaliza tu estrategia",
  why: "Esto nos ayuda a personalizar tu estrategia",
};

export const META_QUESTION = {
  key: "meta_ingresos",
  label: "¿Cuánto te gustaría ganar al mes?",
  options: ["$10,000", "$20,000", "$30,000", "$50,000", "Más de $50,000"],
  optional: true,
  why: "Esto nos ayuda a personalizar tu estrategia",
};

export function getQuestions(businessType) {
  const base = QUESTIONS[businessType] || [];
  return [...base, PRECIO_QUESTION, INGRESOS_QUESTION, META_QUESTION, EXTRA_QUESTION];
}
